import React, { useEffect, useState } from 'react'
import { useOutletsQuery } from '../../Store/Apis/outletApi';
import { useSelector } from 'react-redux';

const AddEditSuplier = ({ handleSubmit, data, cancel }) => {
    const user = useSelector((state) => state.auth.user)
    const isSuperAdmin = user.role === 'superAdmin';
    const getOutletApi = useOutletsQuery();

    const [form, setForm] = useState({
        outlets: [],
        companyName: data?.companyName || '',
        companyEmail: data?.email || '',
        companyPhone: data?.companyPhone || '',
        contactPersonName: data?.contactPerson || '',
        contactPersonPhone: data?.contactPhone || '',
        address: data?.address || '',
        city: data?.city || '',
        pin: data?.pin || ''
    });
    
    useEffect(() => {
        if (getOutletApi.isSuccess) {
            const outlets = getOutletApi.data.data.map(outlet => {
                // Check if the user matches this outlet (non-super user case)
                const isDefaultOutlet = user.outletID === outlet.outletId;
    
                // For non-super users, set isActive to 1 for their outlet
                if (!isSuperAdmin && isDefaultOutlet) {
                    return {
                        outletId: outlet.outletId.toString(),
                        isActive: 1
                    };
                }
    
                // For others, determine based on the provided data (edit case)
                const matchingOutlet = data?.outlets?.find(
                    selectedOutlet => selectedOutlet.outletId.toString() === outlet.outletId.toString()
                );
    
                return {
                    outletId: outlet.outletId.toString(),
                    isActive: matchingOutlet?.isActive === 1 ? 1 : 0,
                    ...(matchingOutlet?.id && { id: matchingOutlet.id }) // Retain `id` if exists
                };
            });
    
            setForm(prevForm => ({ ...prevForm, outlets }));
        }
    }, [getOutletApi.isSuccess, data, user.outletId, isSuperAdmin]);
    

    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (isSuperAdmin && form.outlets.every(outlet => outlet.isActive === 0)) {
            newErrors.outlets = 'Please select at least one outlet';
        }
        if (!form.companyName) newErrors.companyName = 'Company Name is required';
        if (!form.companyEmail) newErrors.companyEmail = 'Company Email is required';
        if (!form.companyPhone) newErrors.companyPhone = 'Company Phone is required';
        if (!form.contactPersonName) newErrors.contactPersonName = 'Contact Person Name is required';
        if (!form.contactPersonPhone) newErrors.contactPersonPhone = 'Contact Person Phone is required';
        if (!form.address) newErrors.address = 'Address is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'outlets') {
            setForm(prevForm => ({
                ...prevForm,
                outlets: prevForm.outlets.map(outlet =>
                    outlet.outletId === value ? { ...outlet, isActive: checked ? 1 : 0 } : outlet
                )
            }));
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            // Check if the data is being added or updated
            const updatedOutlets = form.outlets.map(outlet => {
                const originalOutlet = data?.outlets?.find(o => o.outletId === outlet.outletId);
                
                // If it's an add operation, maintain the user selection
                if (!originalOutlet) {
                    return { ...outlet };
                }
    
                // For edit, preserve original states unless modified
                return originalOutlet.isActive === outlet.isActive
                    ? { ...originalOutlet }
                    : { ...outlet };
            });

            console.log(form)
            
            handleSubmit({ ...form, outlets: updatedOutlets });
        }
    };


    const handleCancel = () => {
        cancel(1)
    }

    return (
        <form onSubmit={handleFormSubmit} noValidate>
            {isSuperAdmin && (
                <div className="mb-3">
                    <label className='fw-500'>Choose Outlet <span className="text-danger ms-1">*</span></label>
                    <div>
                        {getOutletApi.isLoading && <h6>Loading Outlets...</h6>}
                        {getOutletApi.isError && <h6>Something Went Wrong !!</h6>}
                        <div className='border p-3 rounded-3'>
                            <div className="row g-0">
                                {form.outlets.map((outlet, index) => (
                                    <div className="col-lg-3 col-md-3" key={outlet.outletId}>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="outlets"
                                                value={outlet.outletId}
                                                checked={outlet.isActive === 1}
                                                onChange={handleChange}
                                                id={`outlet-${outlet.outletId}`}
                                            />
                                            <label className="form-check-label" htmlFor={`outlet-${outlet.outletId}`}>
                                                {getOutletApi?.data?.data[index]?.outletName}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {errors.outlets && <small className="text-danger">{errors.outlets}</small>}
                </div>
            )}

            <div className="row">
                <div className="col-md-4 mb-3">
                    <label>Company Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="companyName"
                        className={`form-control ${errors.companyName ? 'is-invalid' : ''}`}
                        value={form.companyName}
                        onChange={handleChange}
                        placeholder="Enter Company/Supplier Name"
                    />
                    {errors.companyName && <small className="text-danger">{errors.companyName}</small>}
                </div>
                <div className="col-md-4 mb-3">
                    <label>Company Email <span className="text-danger">*</span></label>
                    <input
                        type="email"
                        name="companyEmail"
                        className={`form-control ${errors.companyEmail ? 'is-invalid' : ''}`}
                        value={form.companyEmail}
                        onChange={handleChange}
                        placeholder="Enter Company Email"
                    />
                    {errors.companyEmail && <small className="text-danger">{errors.companyEmail}</small>}
                </div>

                <div className="col-md-4 mb-3">
                    <label>Company Phone <span className="text-danger">*</span></label>
                    <input
                        type="tel"
                        name="companyPhone"
                        className={`form-control ${errors.companyPhone ? 'is-invalid' : ''}`}
                        value={form.companyPhone}
                        onChange={handleChange}
                        placeholder="Enter Company Phone Number"
                    />
                    {errors.companyPhone && <small className="text-danger">{errors.companyPhone}</small>}
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Contact Person Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="contactPersonName"
                        className={`form-control ${errors.contactPersonName ? 'is-invalid' : ''}`}
                        value={form.contactPersonName}
                        onChange={handleChange}
                        placeholder="Enter Contact Person Name"
                    />
                    {errors.contactPersonName && <small className="text-danger">{errors.contactPersonName}</small>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Contact Person Phone <span className="text-danger">*</span></label>
                    <input
                        type="tel"
                        name="contactPersonPhone"
                        className={`form-control ${errors.contactPersonPhone ? 'is-invalid' : ''}`}
                        value={form.contactPersonPhone}
                        onChange={handleChange}
                        placeholder="Enter Phone Number"
                    />
                    {errors.contactPersonPhone && <small className="text-danger">{errors.contactPersonPhone}</small>}
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 mb-3">
                    <label>Address <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="address"
                        className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                        value={form.address}
                        onChange={handleChange}
                        placeholder="Enter Address"
                    />
                    {errors.address && <small className="text-danger">{errors.address}</small>}
                </div>
                <div className="col-md-4 mb-3">
                    <label>City</label>
                    <input
                        type="text"
                        name="city"
                        className="form-control"
                        value={form.city}
                        onChange={handleChange}
                        placeholder="Enter City Name"
                    />
                </div>

                <div className="col-md-4 mb-3">
                    <label>Pin</label>
                    <input
                        type="number"
                        name="pin"
                        className="form-control"
                        value={form.pin}
                        onChange={handleChange}
                        placeholder="Enter Pin code"
                    />
                </div>
            </div>

            <div className="d-flex justify-content-center">
                <button type="button" className="btn btn-secondary me-2" onClick={handleCancel}>Cancel</button>
                <button type="submit" className="btn btn-primary">Save</button>
            </div>
        </form>
    );
}

export default AddEditSuplier